<template>
  <div class="table-notas">
    <Aguarde :show="httpSend"></Aguarde>
    <!-- Filtros Card -->
    <div class="table-card p-4 mb-section">
      <div class="d-flex justify-content-between align-items-center mb-0">
        <h6 class="m-0 font-weight-bold text-dark"><i class="bx bx-filter-alt mr-1"></i> Filtros de Pesquisa</h6>
        <b-button v-b-toggle.collapse-filtros variant="link"
                  class="text-muted p-0 font-size-13 text-decoration-none shadow-none font-weight-medium">Expandir /
          Ocultar <i class="bx bx-chevron-down align-middle"></i></b-button>
      </div>
      <b-collapse id="collapse-filtros" class="mt-3" v-model="showFiltros">
        <b-form @submit.prevent="selectChange()">
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Ano" label-for="not_emissao_ano" class="mb-2">
                <input id="not_emissao_ano" v-model="filtro.not_emissao_ano" v-mask="'####'" type="text" maxlength="4"
                       class="form-control form-control-sm" placeholder="Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Números Finais" label-for="fnot_numero" class="mb-2">
                <input id="fnot_numero" v-model="filtro.not_numero" type="text" maxlength="11"
                       class="form-control form-control-sm" placeholder="Números após os zeros">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Competência Inicial" label-for="sep_competencia_inicial" class="mb-2">
                <input id="sep_competencia_inicial" v-model="filtro.sep_competencia_inicial" v-mask="'##/####'"
                       type="text" maxlength="7" class="form-control form-control-sm" placeholder="Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Competência Final" label-for="sep_competencia_final" class="mb-2">
                <input id="sep_competencia_final" v-model="filtro.sep_competencia_final" v-mask="'##/####'" type="text"
                       maxlength="7" class="form-control form-control-sm" placeholder="Mês/Ano">
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Emissão Inicial" label-for="not_emissao_incial" class="mb-2">
                <input id="not_emissao_incial" v-model="filtro.not_emissao_incial" type="date" maxlength="10"
                       class="form-control form-control-sm">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Emissão Final" label-for="not_emissao_final" class="mb-2">
                <input id="not_emissao_final" v-model="filtro.not_emissao_final" type="date" maxlength="10"
                       class="form-control form-control-sm">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Nº Nota Inicial" label-for="not_numero_inicial" class="mb-2">
                <input id="not_numero_inicial" v-model="filtro.not_numero_inicial" type="text"
                       v-mask="'###############'" maxlength="15" class="form-control form-control-sm"
                       placeholder="Número completo">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Nº Nota Final" label-for="not_numero_final" class="mb-2">
                <input id="not_numero_final" v-model="filtro.not_numero_final" type="text" v-mask="'###############'"
                       maxlength="15" class="form-control form-control-sm" placeholder="Número completo">
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Tributação" label-for="sep_exigibilidade_iss" class="mb-2">
                <select id="sep_exigibilidade_iss" @change="selectChange()" v-model="filtro.sep_exigibilidade_iss"
                        class="custom-select custom-select-sm" type="text">
                  <option value="">Todos</option>
                  <option value="1">Exigível</option>
                  <option value="2">Não Incidência</option>
                  <option value="3">Isenção</option>
                  <option value="5">Imune</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Situação" label-for="not_cancelada" class="mb-2">
                <select id="not_cancelada" @change="selectChange()" v-model="filtro.not_cancelada"
                        class="custom-select custom-select-sm" type="text">
                  <option value="">Todos</option>
                  <option value="1">Emitida</option>
                  <option value="2">Cancelada</option>
                  <option value="99">Aguardando Pagamento</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Exigibilidade" label-for="sep_municipio_incidencia" class="mb-2">
                <select id="sep_municipio_incidencia" @change="selectChange()" v-model="filtro.sep_municipio_incidencia"
                        class="custom-select custom-select-sm" type="text">
                  <option value="">Todos</option>
                  <option v-bind:value="'='+entidade.mun_codigo">No Município</option>
                  <option v-bind:value="'<>'+entidade.mun_codigo">Fora do Município</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="ISS Retido" label-for="sep_iss_retido" class="mb-2">
                <select id="sep_iss_retido" @change="selectChange()" v-model="filtro.sep_iss_retido"
                        class="custom-select custom-select-sm" type="text">
                  <option value="">Todos</option>
                  <option value="S">Sim</option>
                  <option value="N">Não</option>
                </select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="Nome/Razão Tomador" label-for="fsep_razao_social_tomador" class="mb-2">
                <input id="fsep_razao_social_tomador" v-model="filtro.sep_razao_social_tomador" type="text"
                       maxlength="20" class="form-control form-control-sm">
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="CPF/CNPJ do Tomador" class="mb-2">
                <the-mask class="form-control form-control-sm" v-model="filtro.sep_cpf_cnpj_tomador"
                          :mask="['###.###.###-##', '##.###.###/####-##']"/>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Solicitação de Nota" label-for="tipo_avulsa" class="mb-2">
                <select id="tipo_avulsa" @change="selectChange()" v-model="filtro.tipo_avulsa"
                        class="custom-select custom-select-sm" type="text">
                  <option value="1">Exibir</option>
                  <option value="0">Não Exibir</option>
                </select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Ordenação" label-for="nota_ordenacao" class="mb-0">
                <select id="nota_ordenacao" @change="selectChange()" v-model="filtro.ordenacao"
                        class="custom-select custom-select-sm" type="text">
                  <option value="n.not_emissao desc">Data de Emissão ↓</option>
                  <option value="n.not_emissao">Data de Emissão ↑</option>
                  <option value="sp.sep_valor desc">Valor da Nota ↓</option>
                  <option value="sp.sep_valor">Valor da Nota ↑</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Notas por Página" label-for="nota_pagina" class="mb-0">
                <select id="nota_pagina" @change="selectChange()" v-model="filtro.nota_pagina"
                        class="custom-select custom-select-sm" type="text">
                  <option value="10">10/Pág.</option>
                  <option value="30">30/Pág.</option>
                  <option value="50">50/Pág.</option>
                  <option value="80">80/Pág.</option>
                  <option value="100">100/Pág.</option>
                  <option value="200">200/Pág.</option>
                  <option value="500">500/Pág.</option>
                  <option value="800">800/Pág.</option>
                  <option value="1000">1000/Pág.</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-6 d-flex justify-content-end align-items-end mt-2 mt-md-0">
              <button type="button" @click="lote_xml"
                      class="btn-action btn-action--info mr-2 shadow-none font-weight-medium">
                <i class="bx bx-download label-icon"></i> Baixar lote XML
              </button>
              <button type="submit" class="btn-action btn-action--primary shadow-none font-weight-medium">
                <i class="bx bx-search label-icon"></i> Consultar
              </button>
            </div>
          </div>
        </b-form>
      </b-collapse>
    </div>

    <!-- Métricas -->
    <div class="metrics-grid mb-section" v-show="!httpSend">
      <div class="metric-card metric-card--blue">
        <div class="metric-icon">
          <i class="bx bx-file"></i>
        </div>
        <div class="metric-body">
          <p class="metric-label">Total de Notas</p>
          <p class="metric-value">{{ resumo.total }}</p>
        </div>
      </div>
      <div class="metric-card metric-card--green">
        <div class="metric-icon">
          <i class="bx bx-dollar-circle"></i>
        </div>
        <div class="metric-body">
          <p class="metric-label">Valor Total NFS-e</p>
          <p class="metric-value">{{ resumo.valor_notas | formatNumeroBr }}</p>
        </div>
      </div>
      <div class="metric-card metric-card--amber">
        <div class="metric-icon">
          <i class="bx bx-pie-chart-alt-2"></i>
        </div>
        <div class="metric-body">
          <p class="metric-label">Valor Total ISS</p>
          <p class="metric-value">{{ resumo.valor_iss | formatNumeroBr }}</p>
        </div>
      </div>
    </div>

    <!-- SEM NOTAS MESSAGE -->
    <div v-show="!list_notas || list_notas.length < 1" class="empty-state-card table-card mb-section">
      <div class="empty-state">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
          <circle cx="18" cy="18" r="17" stroke="#e2e8f0" stroke-width="1.5"/>
          <path d="M12 18h12M18 12v12" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <p>Nenhuma nota encontrada com os filtros atuais</p>
      </div>
    </div>

    <!-- AVULSAS (Aguardando Pagamento) -->
    <div class="table-card mb-section" v-if="list_avulsas && list_avulsas.length > 0">
      <div class="table-header">
        <div class="header-left-group">
          <p class="chart-title"><i class="bx bx-time mr-1 text-warning"></i> Notas Avulsas (Aguardando Pagamento)</p>
          <span class="badge-count">{{ list_avulsas.length }} registros</span>
        </div>
      </div>
      <div class="table-wrapper">
        <table class="nf-table">
          <thead>
          <tr>
            <th>Recibo Prov.</th>
            <th>Emissão - Competência</th>
            <th>CPF/CNPJ Tomador</th>
            <th>Tomador</th>
            <th class="td-right">Valor</th>
            <th class="th-status">Situação</th>
            <th class="td-right th-action">Ações</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="g in list_avulsas" :key="g.reb_codigo" class="row--warning">
            <td class="td-mono td-bold">{{ g.reb_numero }}</td>
            <td>
                <span class="vencimento-wrap" style="color: #475569;">
                  <strong>{{ g.reb_emissao | formatDate }}</strong> - {{ g.sep_competencia | formatDateCompetencia }}
                </span>
            </td>
            <td>
              <span class="td-mono text-muted"
                    v-if="g.sep_cpf_cnpj_tomador && g.sep_cpf_cnpj_tomador.length < 12">{{
                  g.sep_cpf_cnpj_tomador | VMask('###.###.###-##')
                }}</span>
              <span class="td-mono text-muted"
                    v-else-if="g.sep_cpf_cnpj_tomador">{{ g.sep_cpf_cnpj_tomador| VMask('##.###.###/####-##') }}</span>
            </td>
            <td><span>{{ g.sep_razao_social_tomador }}</span></td>
            <td class="td-right td-mono font-weight-bold" style="white-space: nowrap;">{{
                g.sep_valor | formatNumeroBr
              }}
            </td>
            <td>
              <span class="status-badge status-badge--pendente">Aguardando Pagto</span>
            </td>
            <td class="td-action text-right">
              <b-dropdown variant="light" size="sm" right no-caret
                          toggle-class="btn-icon shadow-none border-0 text-muted bg-transparent">
                <template #button-content>
                  <i class="bx bx-dots-vertical-rounded font-size-18"></i>
                </template>

                <b-dropdown-item @click="pagamento(g)">
                  <i class="bx bx-money mr-2 text-success"></i> Realizar Pagamento
                </b-dropdown-item>
                <b-dropdown-item v-if="!g.soc_codigo" @click="modalCancelar(g)">
                  <i class="bx bx-x-circle mr-2 text-danger"></i> Cancelar Solicitação
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- NOTAS EMITIDAS -->
    <div class="table-card mb-section" v-if="list_notas && list_notas.length > 0">
      <div class="table-header">
        <div class="header-left-group">
          <p class="chart-title"><i class="bx bx-receipt mr-1 text-primary"></i> Notas Emitidas</p>
          <span class="badge-count">{{ list_notas.length }} nesta página</span>
        </div>
      </div>
      <div class="table-wrapper">
        <table class="nf-table row-border-bottom">
          <thead>
          <tr>
            <th>Número</th>
            <th>Emissão</th>
            <th>CPF/CNPJ</th>
            <th>Destinatário</th>
            <th class="td-right">Valor</th>
            <th class="th-status">Status</th>
            <th class="td-right th-action">Ações</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="g in list_notas" :key="g.tps_codigo" :class="{ 'row--cancelada': g.soc_codigo }">
            <td class="td-mono td-bold">
              <router-link tag="a" v-if="!g.soc_codigo" target="_blank" class="text-primary text-decoration-none"
                           :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: g.not_hash}}">
                {{ g.not_numero || '-' }}
              </router-link>
              <router-link tag="a" v-else target="_blank" class="text-secondary text-decoration-none"
                           :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: g.not_hash}}">
                {{ g.not_numero || '-' }}
              </router-link>
            </td>
            <td>
              <span v-if="!g.not_emissao"> - </span>
              <span v-else class="vencimento-wrap" style="color: #475569;">
                  <strong>{{ g.not_emissao | formatDateHora }}</strong>
                  <span class="text-muted"
                        style="font-size: 11px; display:block;">{{ g.sep_competencia | formatDateCompetencia }}</span>
                </span>
            </td>
            <td>
              <span class="td-mono text-muted"
                    v-if="g.sep_cpf_cnpj_tomador && g.sep_cpf_cnpj_tomador.length < 12">{{
                  g.sep_cpf_cnpj_tomador | VMask('###.###.###-##')
                }}</span>
              <span class="td-mono text-muted"
                    v-else-if="g.sep_cpf_cnpj_tomador">{{ g.sep_cpf_cnpj_tomador| VMask('##.###.###/####-##') }}</span>
            </td>
            <td><span>{{ g.sep_razao_social_tomador }}</span></td>
            <td class="td-mono td-right" :class="{ 'text-muted text-decoration-line-through': g.soc_codigo }"
                style="white-space: nowrap;">{{ g.sep_valor | formatNumeroBr }}
            </td>
            <td style="white-space: nowrap;">
              <span v-show="g.soc_codigo" class="status-badge status-badge--cancelada">Cancelada</span>
              <span v-show="g.not_numero && !g.soc_codigo" class="status-badge status-badge--autorizada">Emitida</span>
              <i v-show="g.soc_codigo && g.soc_motivo && g.substituicao"
                 class="bx bx-revision text-danger ml-1 font-size-16 align-middle" style="cursor: help;"
                 v-b-tooltip.hover title="Cancelada e Substituída"></i>
              <i v-show="g.substituida" class="bx bx-revision text-info ml-1 font-size-16 align-middle"
                 style="cursor: help;" v-b-tooltip.hover title="Esta nota substitui uma anterior"></i>
            </td>
            <td class="td-action text-right">
              <b-dropdown variant="light" size="sm" right no-caret
                          toggle-class="btn-icon shadow-none border-0 text-muted bg-transparent">
                <template #button-content>
                  <i class="bx bx-dots-vertical-rounded font-size-18"></i>
                </template>

                <b-dropdown-item :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: g.not_hash}}">
                  <i class="bx bx-show mr-2 text-primary"></i> <span
                    v-if="!g.soc_codigo">Visualizar Detalhes</span><span v-else
                                                                         class="text-muted">Visualizar Detalhes</span>
                </b-dropdown-item>

                <b-dropdown-item @click="baixar_nota(g)">
                  <i class="bx bxs-file-pdf mr-2 text-secondary"></i> Baixar PDF
                </b-dropdown-item>

                <b-dropdown-item @click="baixar_xml(g)">
                  <i class="bx bx-code-alt mr-2 text-info"></i> Baixar XML
                </b-dropdown-item>

                <b-dropdown-divider
                    v-if="g.soc_motivo && g.substituicao || g.substituida || (!g.soc_codigo && !g.substituicao) || !g.soc_codigo"></b-dropdown-divider>

                <b-dropdown-item v-if="g.soc_motivo && g.substituicao"
                                 :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: g.substituicao}}">
                  <i class="bx bx-link-external mr-2 text-dark"></i> Ver Nota Substituta
                </b-dropdown-item>

                <b-dropdown-item v-if="g.substituida"
                                 :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: g.substituida}}">
                  <i class="bx bx-exit mr-2 text-dark"></i> Ver Nota Substituída
                </b-dropdown-item>

                <b-dropdown-item v-if="!g.soc_codigo && !g.substituicao" @click="substituir(g)">
                  <i class="bx bx-revision mr-2 text-warning"></i> Substituir Nota
                </b-dropdown-item>

                <b-dropdown-item v-if="!g.soc_codigo" @click="modalCancelar(g)">
                  <i class="bx bx-x-circle mr-2 text-danger"></i> Cancelar Nota
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-show="list_notas && list_notas.length > 0" class="row">
      <div class="col-lg-12 d-flex justify-content-center">
        <paginate
            v-model="filtro.pagina"
            :page-count="total_paginas"
            :page-range="3"
            :margin-pages="3"
            :click-handler="proximaPagina"
            :prev-text="'‹ Anterior'"
            :next-text="'Próxima ›'"
            :prev-link-class="'page-link'"
            :next-link-class="'page-link'"
            :page-link-class="'page-link'"
            :container-class="'pagination pagination-rounded mt-4'"
            :page-class="'page-item'">
        </paginate>
      </div>
    </div>

    <!-- MODAL CANCELAMENTO -->
    <b-modal
        id="modal-cancela-nota"
        ref="modal-cancela-nota"
        size="lg"
        title="Opcões de Cancelamento da Nota"
        title-class="font-weight-bold"
        header-bg-variant="white"
        header-border-variant="light"
        footer-bg-variant="light"
        :hide-header-close="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true">
      <div class="modal-body pb-0 pt-2">
        <div class="card bg-light shadow-none border-0 mb-4 p-3 rounded">
          <div class="row">
            <div class="col-md-3">
              <small class="text-muted d-block">Nota Fiscal</small>
              <strong>{{ nota.not_numero }}</strong>
            </div>
            <div class="col-md-3">
              <small class="text-muted d-block">Emissão</small>
              <strong>{{ nota.not_emissao | formatDate }}</strong>
            </div>
            <div class="col-md-6 border-left border-white">
              <small class="text-muted d-block">Tomador</small>
              <strong>{{ nota.sep_razao_social_tomador }}</strong>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-7">
            <b-form-group label="Motivo do Cancelamento" label-class="font-weight-bold" label-for="soc_motivo">
              <select id="soc_motivo" v-model="cancelamento.soc_motivo" class="custom-select custom-select-sm"
                      :class="{ 'is-invalid': $v.cancelamento.soc_motivo.$error }" type="text">
                <option value="1">Erro na Emissão</option>
                <option value="2">Serviço não Prestado</option>
                <option value="9">Outros</option>
              </select>
              <div v-if="$v.cancelamento.soc_motivo.$error" class="invalid-feedback">Informe o motivo do cancelamento
              </div>
            </b-form-group>
          </div>
        </div>

        <b-form-group label="Justificativa" label-class="font-weight-bold">
          <textarea v-model="cancelamento.soc_justificativa" class="form-control"
                    :class="{'is-invalid': $v.cancelamento.soc_justificativa.$error }" :maxlength="200" rows="3"
                    placeholder="Por que a nota está sendo cancelada?"></textarea>
          <div class="text-right mt-1">
            <small class="text-muted"
                   :class="{ 'text-danger': cancelamento.soc_justificativa && cancelamento.soc_justificativa.length === 200 }">
              {{ cancelamento.soc_justificativa ? cancelamento.soc_justificativa.length : 0 }} / 200
            </small>
          </div>
          <div v-show="$v.cancelamento.soc_justificativa.$error" class="invalid-feedback d-block mt-0">Informe a
            justificativa
          </div>
        </b-form-group>

        <div v-show="!cancelamento_automatico" class="mt-3 bg-white p-3 border rounded shadow-sm">
          <b-form-group label="Declaração do tomador" label-class="font-weight-bold text-danger mb-2">
            <vue-dropzone id="dropzone" ref="myVueDropzone" v-on:vdropzone-processing="sendFileProcessing"
                          v-on:vdropzone-success="sendFileComplete" v-on:vdropzone-removed-file="sendFileRemove"
                          :options="dropzoneOptions"></vue-dropzone>
            <small class="text-muted d-block mt-2">Apenas arquivo PDF com tamanho máximo de 2MB.</small>
            <div v-if="erros.arquivo" class="text-danger mt-1 font-size-12"><i class="bx bx-error"></i> Necessário
              enviar o arquivo
            </div>
          </b-form-group>
        </div>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <button v-if="httpSendFile" type="button" disabled class="btn btn-success px-4"><i
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i> Carregando
        </button>
        <b-button v-else variant="danger" class="px-4 shadow-none" @click="cancelarNota()">Confirmar Cancelamento
        </b-button>
        <b-button variant="outline-dark" class="px-3 shadow-none" @click="closeModal('modal-cancela-nota')">Apenas
          Fechar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import {required} from "vuelidate/lib/validators";
import Paginate from 'vuejs-paginate'
import {TheMask} from 'vue-the-mask'
import Aguarde from "@/components/widgets/aguarde";
import {cancelarNota, downloadLoteXML, downloadNota, downloadNotaXML, listNotas} from "@/api/nfse/nota";
import Swal from "sweetalert2";
import {getEntidade} from "@/api/config/init";
import {getToken} from "@/api/config/token";
import {uploadCancelamento} from "@/api/core/upload";
import moment from "moment";
import router from "@/router";

export default {
  components: {
    Aguarde,
    TheMask,
    Paginate,
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      showFiltros: localStorage.getItem('table_notas_filtros') === 'true',
      list_notas: [],
      list_avulsas: [],
      httpSend: false,
      httpSendFile: false,
      filtro: {
        eco_codigo: null,
        ordenacao: "n.not_emissao desc",
        pagina: 1,
        nota_pagina: "50",
        not_emissao_ano: "",
        not_numero: "",
        sep_competencia_inicial: "",
        sep_competencia_final: "",
        not_emissao_incial: moment().startOf('year').format('YYYY-MM-DD'),
        not_emissao_final: moment().format('YYYY-MM-DD'),
        not_numero_inicial: "",
        not_numero_final: "",
        sep_exigibilidade_iss: "",
        not_cancelada: "",
        sep_municipio_incidencia: "",
        sep_iss_retido: "",
        sep_cpf_cnpj_tomador: "",
        sep_razao_social_tomador: "",
        tipo_avulsa: "1",
      },
      resumo: {
        total: 0,
        valor_notas: 0,
        valor_iss: 0
      },
      total_paginas: 0,
      nota: {},
      cancelamento_automatico: false,
      cancelamento: {
        soc_codigo: null,
        soc_motivo: '',
        soc_justificativa: '',
        not_codigo: null,
        soc_nota_correta: null,
        soc_arquivo: ''
      },
      erros: {
        nota_correta: false,
        arquivo: false
      },
      dropzoneOptions: {
        dictFileTooBig: "O arquivo é muito grande ({{filesize}}MB). Tamanho máximo permitido: {{maxFilesize}}MB",
        dictRemoveFile: "Clique aqui para remover",
        dictCancelUpload: "Cancelar envio",
        dictCancelUploadConfirmation: "Tem certeza de que deseja cancelar o envio ?",
        dictMaxFilesExceeded: "Você não pode enviar mais arquivos",
        url: uploadCancelamento(),
        paramName: "arquivo",
        createImageThumbnails: false,
        acceptedFiles: "application/pdf",
        disablePreviews: true,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='mdi mdi-upload'></i> Solte o arquivo, ou clique aqui para selecionar",
        headers: {"X-ACCESS-ENTIDADE": getEntidade(), "X-ACCESS-TOKEN": getToken()}
      }
    };
  },
  validations: {
    cancelamento: {
      soc_motivo: {
        required
      },
      soc_justificativa: {
        required,
      },
    },
  },
  watch: {
    showFiltros(val) {
      localStorage.setItem('table_notas_filtros', val);
    }
  },
  created() {
    if (this.empresa) {
      this.filtro.eco_codigo = this.empresa.eco_codigo;
      if (this.$route.query.nota_pagina) {
        this.filtro = this.$route.query;
        this.filtro.pagina = parseInt(this.filtro.pagina)
        this.getNota();
      } else {
        this.getNota();
      }
    }
  },
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
  },
  methods: {
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.filtro.pagina = pageNum;
      this.getNota()
    },
    resetCancelamento() {
      this.cancelamento = {
        soc_codigo: null,
        soc_motivo: '',
        soc_justificativa: '',
        not_codigo: null,
        soc_nota_correta: null,
        soc_arquivo: ''
      }
      this.erros.arquivo = false;
      this.erros.nota_correta = false;
    },
    sendFileProcessing(file) {
      this.httpSendFile = true;
      console.log("file", file)
    },
    sendFileComplete(file, response) {
      if (response.status) {
        this.cancelamento.soc_arquivo = response.dados
      } else {
        const msg = response.mensagem;
        if (typeof msg === 'object') {
          this.$toast.error(JSON.stringify(msg));
        } else {
          this.$toast.error(msg);
        }
        this.$refs.myVueDropzone.removeAllFiles()
      }
      this.httpSendFile = false;
    },
    sendFileRemove(file, error) {
      this.cancelamento.soc_arquivo = '';
      console.log(file)
      console.log(error)
    },
    getNota() {
      this.httpSend = true;
      listNotas(this.empresa.eco_codigo, this.filtro).then(result => {
        this.resumo = result.dados.resumo;
        this.total_paginas = result.dados.paginas;
        this.list_notas = result.dados.notas;
        this.list_avulsas = result.dados.avulsas;
        router.replace({query: {...this.filtro, t: new Date().getTime().toString()}})
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    selectChange() {
      this.filtro.pagina = 1;
      this.getNota();
    },
    detalhe(nota) {
      this.$router.push({
        name: 'admin-liberacao-pessoa-detalhe',
        params: {tps_hash: nota.tps_hash}
      })
    },
    substituir(nota) {
      let prazo = parseInt(this.entidade.par_prazo_subistituir)
      let dias_emissao = parseInt(nota.dias_emissao)
      if (dias_emissao > prazo) {
        Swal.fire({
          icon: 'info',
          title: 'Prazo Excedido',
          text: 'Excedido o prazo de ' + this.entidade.par_prazo_subistituir + ' dias para realizar a substituição',
          confirmButtonText: 'Fechar'
        })
      } else {
        this.$router.push({
          name: 'contribuinte-nota-fiscal-substituir',
          params: {not_hash: nota.not_hash}
        })
      }
    },
    modalCancelar(nota) {
      this.prazoCancelamento(nota);
      this.nota = nota;
      this.$refs['modal-cancela-nota'].show();
    },
    prazoCancelamento(nota) {
      const prazo = parseInt(this.entidade.par_prazo_autocancelar)
      if (prazo < 1) {
        this.cancelamento_automatico = false;
      } else {
        const dias_emissao = parseInt(nota.dias_emissao)
        this.cancelamento_automatico = (dias_emissao <= prazo);
      }
    },
    cancelarNota() {
      this.erros.arquivo = false;
      this.erros.nota_correta = false;
      this.$v.$touch();
      if (this.$v.cancelamento.$invalid) {
        return false;
      }
      if (!this.cancelamento_automatico && this.cancelamento.soc_arquivo === '') {
        this.erros.arquivo = true;
        return false;
      }
      this.cancelamento.not_codigo = this.nota.not_codigo;
      this.httpSend = true;
      cancelarNota(this.cancelamento).then(result => {
        if (result.status) {
          this.getNota();
          this.$toast.success(result.mensagem)
          this.closeModal('modal-cancela-nota');
          this.resetCancelamento();
        } else {
          this.$toast.error(result.mensagem);
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    closeModal(ref) {
      this.nota = {};
      this.$refs[ref].hide();
    },
    visualiza_nota(not_hash) {
      this.$router.push({name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: not_hash}})
    },
    baixar_nota(nota) {
      this.httpSend = true;
      downloadNota(nota.not_hash).then(result => {
        if (result.status) {
          window.open(result.mensagem, '_blank');
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    baixar_xml(nota) {
      this.httpSend = true;
      downloadNotaXML(nota.not_hash).then(result => {
        if (result.status) {
          window.open(result.mensagem, '_blank');
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    lote_xml() {
      if (this.filtro.nota_pagina !== '') {
        Swal.fire({
          title: "Atenção apenas as notas exibidas na tela serão baixas.",
          html: 'Para baixar todas as notas selecione "Sem Limite" no campo "Notas por Página".<br> Deseja baixar somente as notas exibidas na tela ?',
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#100e0e",
          confirmButtonText: "Sim",
          cancelButtonText: "Não"
        }).then(result => {
          if (result.isConfirmed) {
            this.baixar_lote_xml();
          }
        });
      } else {
        this.baixar_lote_xml();
      }
    },
    baixar_lote_xml() {
      this.httpSend = true;
      downloadLoteXML(this.filtro).then(result => {
        if (result.status) {
          window.open(result.mensagem, '_blank');
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    pagamento(guia) {
      this.$router.push({
        name: "contribuinte-financeiro-pagamento",
        params: {dam_hash: guia.dam_hash}
      })
    },
  }
};
</script>
<style scoped>
/* Dashboard Styling Tokens */
.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.mb-section {
  margin-bottom: 8px;
}

.metric-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: box-shadow 0.2s;
}

.metric-card:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
}

.metric-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.metric-card--blue .metric-icon {
  background: #eff6ff;
  color: #3b82f6;
}

.metric-card--green .metric-icon {
  background: #f0fdf4;
  color: #22c55e;
}

.metric-card--amber .metric-icon {
  background: #fffbeb;
  color: #f59e0b;
}

.metric-card--teal .metric-icon {
  background: #f0fdfa;
  color: #14b8a6;
}

.metric-body {
  flex: 1;
}

.metric-label {
  margin: 0 0 2px;
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.metric-value {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
}

.table-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.table-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.chart-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
}

.badge-count {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  background: #f1f5f9;
  border-radius: 999px;
  padding: 2px 10px;
  margin-left: 10px;
}

.table-wrapper {
  min-height: 20rem;
  padding-bottom: 30px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.nf-table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  font-size: 12px;
}

.nf-table thead th {
  background: #f8fafc;
  padding: 10px 1rem;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #e2e8f0;
}

.nf-table tbody td {
  padding: 5px 0.5rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.nf-table tbody tr:last-child td {
  border-bottom: none;
}

.nf-table tbody tr:hover {
  background: #f8fafc;
}

.row--cancelada td {
  background-color: #f9e9e980;
}

.row--warning td {
  background-color: #fffbeb !important;
}

.td-bold {
  font-weight: 600;
  color: #0f172a;
}

.td-right, .th-right {
  text-align: right;
}

/* Largura da coluna Ações (Altere o valor de 60px abaixo caso ache necessário) */
.th-action {
  width: 10px;
}

/* Largura da coluna Status/Situação (Altere o valor abaixo caso ache necessário) */
.th-status {
  width: 110px;
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.status-badge--autorizada {
  background: #22c55e1a;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.status-badge--pendente {
  background: #f59e0b1a;
  color: #92400e;
  border: 1px solid #fde68a;
}

.status-badge--cancelada {
  background: #ef44441a;
  color: #991b1b;
  border: 1px solid #fecaca;
}

.status-badge--substituida {
  background: #f3f4f6;
  color: #4b5563;
  border: 1px solid #d1d5db;
}

.status-badge--info {
  background: #e0f2fe;
  color: #0284c7;
  border: 1px solid #bae6fd;
  font-size: 10px;
  padding: 2px 8px;
}

.btn-group-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex-wrap: wrap;
}

.btn-icon {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-icon--primary {
  background: #eff6ff;
  color: #3b82f6;
}

.btn-icon--primary:hover {
  background: #3b82f6;
  color: #fff;
}

.btn-icon--secondary {
  background: #f1f5f9;
  color: #475569;
}

.btn-icon--secondary:hover {
  background: #475569;
  color: #fff;
}

.btn-icon--info {
  background: #e0f2fe;
  color: #0284c7;
}

.btn-icon--info:hover {
  background: #0284c7;
  color: #fff;
}

.btn-icon--warning {
  background: #fffbeb;
  color: #d97706;
}

.btn-icon--warning:hover {
  background: #d97706;
  color: #fff;
}

.btn-icon--danger {
  background: #fef2f2;
  color: #dc2626;
}

.btn-icon--danger:hover {
  background: #dc2626;
  color: #fff;
}

.btn-icon--dark {
  background: #f8fafc;
  color: #0f172a;
  border: 1px solid #e2e8f0;
}

.btn-icon--dark:hover {
  background: #0f172a;
  color: #fff;
}

.empty-state {
  text-align: center;
  padding: 3rem 1.5rem;
  color: #64748b;
}

.empty-state svg {
  margin-bottom: 12px;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-action--info {
  background: #e0f2fe;
  color: #0284c7;
}

.btn-action--info:hover {
  background: #bae6fd;
}

.btn-action--primary {
  background: #3b82f6;
  color: #fff;
}

.btn-action--primary:hover {
  background: #2563eb;
}
</style>
<style>
/* Dropzone globals */
.dropzone .dz-preview {
  display: inherit;
}

.vue-dropzone > .dz-preview .dz-remove {
  padding: 5px;
  bottom: 5px;
}
</style>
